import {loginContainer, ConfigObjectType} from '@wallaby-ui/core';
import {NavigationContainer, NavigationContext, ValuesToCopy} from '@wallaby-ui/document';
import * as React from 'react';

import styles from './AppLayout.less';

interface OwnProps {
  config: ConfigObjectType;
  children: React.ReactNode;
  logoName: string;
  logoSignName: string;
  navigationContext: NavigationContext;
  valuesToCopy: ValuesToCopy;
}

type Props = OwnProps;

export const AppLayout: React.FC<Props> = (props) => {
  const {config, children, logoName, logoSignName, navigationContext, valuesToCopy} = props;
  const {isNavigationOpen} = navigationContext;
  return (
    <div data-name='app-layout' data-open={isNavigationOpen} className={styles.dlMainContainerLayout}>
      <div className={styles.dlScrollableColumn}>
        <div data-name='content-column' className={styles.dlContentColumn}>
          {children}
        </div>
        <div className={styles.dlLeftColumn}>
          <NavigationContainer
            logoName={logoName}
            logoSignName={logoSignName}
            loginStateId={loginContainer.LOGIN_REDUCER_STATE_ID}
            config={config}
            navigationContext={navigationContext}
            valuesToCopy={valuesToCopy}
          />
        </div>
      </div>
    </div>
  );
};

AppLayout.displayName = 'AppLayout';
